module.exports = __webpack_public_path__ + "static/media/password_entry.6f807e28.png";